<template>
  <div>
    <div class="mb-4">
      <p>※ 각 부서에서 관리감독자가 담당종사자를 직접 작성하는 페이지입니다.</p>
      <p>※ 최초 작성 후 변동사항이 생겼을시 이전에 작성했던 문서를 열어 수정하여 저장합니다.</p>
    </div>
    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      :types="['department', 'com_name', 'rank', 'writer_name', 'date']"
      :typeslabel="{
        date: '등록일',
      }"
    />

    <!--    종사자 소속-->
    <vs-row class="mt-4">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 종사자 소속</h5>
      </vs-col>
    </vs-row>
    <div class="writeGridContainer mt-4">
      <div class="col-span-12">
        <div class="">부서명</div>
        <span v-if="isPrint" class="print-input"> {{ form.fieldNames }} </span>
        <multiselect v-else :options="fieldNameList" v-model="form.fieldNames" :multiple="true" placeholder="" selectLabel="" deselectLabel="" :showNoResults="false">
          <template slot="option" slot-scope="props">
            <div>{{ props.option }}</div>
          </template>
        </multiselect>
      </div>
    </div>

    <!--    종사자 정보-->
    <vs-row class="mt-4">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 종사자 정보</h5>
      </vs-col>
    </vs-row>
    <div class="writeGridContainer mt-4">
      <div>
        <div class="">ID(사번)</div>
        <p v-if="isPrint" class="print-input flex-1">{{ form.employee_id }}</p>
        <ml-input readonly :disabled="!postId" v-else :value="postId ? form.employee_id : '자동생성'" />
      </div>
      <div>
        <div>생년월일</div>
        <p v-if="isPrint" class="print-input flex-1">
          {{ form.enc.date_of_birth }}
        </p>
        <date-selector v-else :readonly="board.readonly" v-model="form.enc.date_of_birth" :danger="danger.date_of_birth" danger-text="생년월일을 선택하세요"/>
      </div>
      <div>
        <div>팀명</div>
        <p v-if="isPrint" class="print-input flex-1">{{ form.targetCompany }}</p>
        <company-selector v-else
                          v-model="form.department_name"
                          :company-name="form.targetCompany"
                          :field-id="form.stdInfo.field_id"
                          :danger="danger.department_name"
                          danger-text="팀명을 선택하세요"
                          class="w-full flex-1"
                          @select="selectCompany" />
      </div>

      <div>
        <div>업무분야</div>
        <vs-select autocomplete v-model="form.job_category" placeholder="판단이 어려울 경우 중대재해예방팀으로 문의 바랍니다." :danger="danger.job_category" danger-text="업무분야를 선택하세요">
          <vs-select-item v-for="divide in divideList" :key="divide" :text="divide" :value="divide" />
        </vs-select>
      </div>
      <div>
        <div>직종</div>
        <vs-select autocomplete v-model="form.employment_type" :danger="danger.employment_type" danger-text="직종을 선택하세요">
          <vs-select-item v-for="job in jobList" :key="job" :text="job" :value="job" />
        </vs-select>
      </div>
      <div>
        <div>성별</div>
        <p v-if="isPrint" class="print-input flex-1">{{ form.enc.gender }}</p>
        <vs-select v-else autocomplete v-model="form.enc.gender" :disabled="board.readonly" :danger="danger.gender" danger-text="성별을 선택하세요">
          <vs-select-item v-for="gender in ['남', '여']" :key="gender" :text="gender" :value="gender" />
        </vs-select>
      </div>

      <div>
        <div>성명</div>
        <p v-if="isPrint" class="print-input flex-1">{{ form.enc.full_name || form.full_name }}</p>
        <ml-input :readonly="board.readonly" v-else v-model="form.enc.full_name" :danger="danger.full_name" danger-text="성명을 입력하세요"/>
      </div>
      <div>
        <div>입사일</div>
        <p v-if="isPrint" class="print-input">{{ form.hire_date }}</p>
        <date-selector v-else v-model="form.hire_date" :readonly="board.readonly" :danger="danger.hire_date" danger-text="입사일을 선택하세요"/>
      </div>
      <div>
        <div>종료 예정일</div>
        <p v-if="isPrint" class="print-input">{{ form.exp_retirement_date }}</p>
        <date-selector v-else v-model="form.exp_retirement_date" :readonly="board.readonly" :danger="danger.exp_retirement_date" danger-text="종료 예정일을 선택하세요"/>
      </div>

      <div>
        <div>핸드폰</div>
        <p v-if="isPrint" class="print-input flex-1">{{ form.enc.contact_number || form.contact_number }}</p>
        <ml-input :readonly="board.readonly" v-else v-model="form.enc.contact_number" :danger="danger.contact_number" danger-text="핸드폰 번호를 입력하세요."/>
      </div>
      <div>
        <div>행정전화</div>
        <p v-if="isPrint" class="print-input">{{ form.enc.contact_number_2 }}</p>
        <ml-input :readonly="board.readonly" v-else v-model="form.enc.contact_number_2" />
      </div>
      <div>
        <div>종료일</div>
        <p v-if="isPrint" class="print-input">{{ form.retirement_date }}</p>
        <date-selector v-else v-model="form.retirement_date" :readonly="board.readonly" />
      </div>
    </div>

    <!--    안전·보건 교육 이수 현황-->
    <vs-row class="mt-4">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 안전·보건 교육 이수 현황</h5>
      </vs-col>
    </vs-row>
    <div class="mt-4">
      <table class="border-left border-right">
        <thead>
          <tr style="background-color: #fafafa">
            <th v-for="(item, index) in keys" :key="index" style="padding-top: 8px; padding-bottom: 8px">{{ item }}</th>
          </tr>
        </thead>
        <tbody>
          <tr style="background-color: #ffffff">
            <!-- 각 td의 폭을 같게 설정한다 -->
            <td v-for="(item, index) in educationHours" :key="index" class="hoursTd" :style="{ width: `${100 / keys.length}%` }">
              <div v-if="item <= 0" class="flex justify-center">
                <img src="@/assets/icons/education_red_dot.svg" :alt="floatToTimeString(item)" />
              </div>
              <div v-else class="flex justify-center">{{ floatToTimeString(item) }}</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import DateSelector from "@/components/selector/DateSelector.vue";
import Multiselect from "vue-multiselect";
import CompanySelector from "@/components/selector/CompanySelector.vue";
import { required, minLength } from "vuelidate/lib/validators";

export default {
  components: {
    CompanySelector,
    DateSelector,
    FieldSelectModule,
    FileUploadModule,
    Multiselect,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  validations: {
    form: {
      fieldNames: { required, minLength: minLength(1) },
      employee_id: { required },
      enc: {
        date_of_birth: { required },
        gender: { required },
        full_name: { required },
        contact_number: { required },
      },
      department_name: { required },
      job_category: { required },
      employment_type: { required },
      hire_date: { required },
      exp_retirement_date: { required },
    },
  },
  watch: {
    "value": {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }

        if (value.field_names && value.field_names.length > 0 && !value.fieldNames) {
          this.form.fieldNames = JSON.parse(JSON.stringify([...this.form.fieldNames, ...value.field_names]));
        }
      },
    },
    "form": {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;


        if (value) {
          if (value.enc.date_of_birth) {
            this.danger.date_of_birth = false;
          }
          if (value.enc.gender) {
            this.danger.gender = false;
          }
          if (value.enc.full_name) {
            this.danger.full_name = false;
          }
          if (value.enc.contact_number) {
            this.danger.contact_number = false;
          }

          if (value.department_name) {
            this.danger.department_name = false;
          }

          if (value.job_category) {
            this.danger.job_category = false;
          }

          if (value.employment_type) {
            this.danger.employment_type = false;
          }

          if (value.hire_date) {
            this.danger.hire_date = false;
          }

          if (value.exp_retirement_date) {
            this.danger.exp_retirement_date = false;
          }

        }

        this.$emit("input", value);

        // this.postId 값이 존재하고, this.employeeDetail 값이 빈 오브젝트일 경우, loadEmployeeDetail 메서드를 실행
        if (this.postId && Object.keys(this.employeeDetail).length === 0) {
          this.loadEmployeeDetail();
        }
      },
    },
    "form.fieldNames": {
      immediate: true,
      deep: true,
      handler(/*value*/) {
        const fields = [];
        if (this.form.fieldNames.length > 0) {
          for (const fieldName of this.form.fieldNames) {
            const field = this.fieldList.find((e) => e.field_name === fieldName);
            if (field && field.id) {
              fields.push(field.id);
            }
          }
        }
        this.form.fields = fields;
      },
    },
    'form.hire_date': {
      immediate: true,
      deep: true,
      handler(value) {
        if (!this.postId) {
          this.form.employee_id = new Date(this.form.hire_date).format('yyyyMMdd') + `${this.nextNumberOfEmployee}`.padStart(4, '0');
        }
      },
    },
    'nextNumberOfEmployee': {
      immediate: true,
      deep: true,
      handler(value) {
        if (!this.postId) {
          this.form.employee_id = new Date(this.form.hire_date).format('yyyyMMdd') + `${this.nextNumberOfEmployee}`.padStart(4, '0');
        }
      },
    }
  },
  computed: {
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
    postId() {
      return parseInt(this.$route.params.postId);
    },
    fieldList() {
      if (this.$store.state.project.fieldListInfo.data) {
        return this.$store.state.project.fieldListInfo.data;
      }
      return [];
    },
    fieldNameList() {
      if (this.$store.state.project.fieldListInfo.data) {
        const list = [];
        for (const field of this.$store.state.project.fieldListInfo.data) {
          list.push(field.field_name);
        }

        return list;
      }

      return [];
    },
  },
  data() {
    return {
      // 종사자 상세 정보 조회를 시작했을 경우 true
      isStartLoadEmployeeDetail: false,
      employeeDetail: {},

      keys: ["정기안전교육", "특별안전보건교육", "채용시 안전교육", "작업내용 변경시 안전교육", "안전보건총괄책임자 교육", "안전보건관리책임자 교육", "관리감독자 안전교육", "MSDS", "기타", "계"],
      educationHours: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      form: {
        stdInfo: {},
        fileList: [],
        enc: {
          date_of_birth: "", // 생년월일
          full_name: "", // 성명
          contact_number: "", // 연락처
          contact_number_2: "", // 행정전화
          contact_number_3: "",
          gender: "", // 성별
        },
        employee_id: "", // 사번
        department_name: "", // 부서명 (no)
        job_category: "", // 구분
        employment_type: "", // 직종
        job_title: "", // 직급

        hire_date: "", // 입사일
        current_position_date: "", // 현보직일
        exp_retirement_date: "", // 종료 예정일
        retirement_date: "", // 퇴임일

        fieldNames: [],
        field_names: [],
        targetCompany: "", // 부서명
      },
      danger: {
        date_of_birth: false, // 생년월일 enc
        department_name: false, // 팀명
        job_category: false, // 업무분야
        employment_type: false, // 직종
        gender: false, // 성별 enc
        full_name: false, // 성명 enc
        hire_date: false, // 입사일
        exp_retirement_date: false, // 종료 예정일
        contact_number: false, // 핸드폰 enc
      },

      divideList: [
        "청사 경비, 시설물 유지관리 업무",
        "도로의 유지·보수 등의 업무",
        "환경미화 업무",
        "공원·녹지 등의 유지관리 업무",
        "산림조사 및 산림보호 업무",
        "조리실무 및 급식실 운영",
        "기타(공공행정과 업무형태 다름)",
        "비현업(사무보조, 아동복지교사 등)"
      ],
      jobList: [
        "공무원",
        "공무직",
        "기간제",
        "청원경찰",
        "공공근로",
        "노인일자리",
        "장애인일자리",
        "지역공동체",
        "자활",
        "기타"
      ],

      nextNumberOfEmployee: 1,
    };
  },
  async mounted() {
    await this.loadFieldList();
    if (!this.postId) {
      await this.autoEmployeeId();
    }
  },
  methods: {
    validate() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        if (!this.$v.form.fieldNames.required) {
          alert("부서명을 한 개 이상 선택해야 합니다");
          return false;
        }

        let error = false;
        if (!this.$v.form.enc.date_of_birth.required) {
          error = true;
          this.danger.date_of_birth = true;
        } else this.danger.date_of_birth = false;

        if (!this.$v.form.enc.gender.required) {
          error = true;
          this.danger.gender = true;
        } else this.danger.gender = false;

        if (!this.$v.form.enc.full_name.required) {
          error = true;
          this.danger.full_name = true;
        } else this.danger.full_name = false;

        if (!this.$v.form.enc.contact_number.required) {
          error = true;
          this.danger.contact_number = true;
        } else this.danger.contact_number = false;

        if (!this.$v.form.department_name.required) {
          error = true;
          this.danger.department_name = true;
        } else this.danger.department_name = false;

        if (!this.$v.form.job_category.required) {
          error = true;
          this.danger.job_category = true;
        } else this.danger.job_category = false;

        if (!this.$v.form.employment_type.required) {
          error = true;
          this.danger.employment_type = true;
        } else this.danger.employment_type = false;

        if (!this.$v.form.hire_date.required) {
          error = true;
          this.danger.hire_date = true;
        } else this.danger.hire_date = false;

        if (!this.$v.form.exp_retirement_date.required) {
          error = true;
          this.danger.exp_retirement_date = true;
        } else this.danger.exp_retirement_date = false;

        if (error) {
          alert("입력되지 않은 필수 항목이 있습니다. 모든 필수 항목을  입력한 후 저장 해주세요")
          return false;
        }
      }

      return true;
    },
    async loadFieldList() {
      const projectId = this.projectId;
      const page = 1;
      const perPage = 1000;

      await this.$store.dispatch("project/LOAD_FIELD_LIST", { projectId, page, perPage, showAll: true });
    },
    async autoEmployeeId() {
      // ID(사번) 자동생성을 위해 total 값을 조회한다
      // 입사일 + 순번
      await this.$store.dispatch("employee/LOAD_EMPLOYEE_LIST", { projectId: this.projectId, perPage: 1 }).then((value) => {
        this.nextNumberOfEmployee = value.total + 1
      });
    },
    selectCompany(value) {
      this.form.targetCompany = value.com_name;
    },
    // 종사자 정보 상세 정보를 불러온다
    async loadEmployeeDetail() {
      if (this.isStartLoadEmployeeDetail) {
        return;
      }

      this.isStartLoadEmployeeDetail = true;
      this.employeeDetail = await this.$store.dispatch("employee/LOAD_EMPLOYEE_DETAIL", {
        projectId: this.projectId,
        post_id: this.postId,
        date_name: 'body.교육기간.시작',
        board_ids: [434, 377],
      });

      // this.employeeDetail.education 배열을 조회한다.
      // education_type 값이 keys 배열에 존재하는 값이면, education_hours 값을 educationHours 배열에 입력한다
      if (this.employeeDetail.education) {
        let sum = 0;
        const newEducationHours = Array(this.keys.length).fill(0);
        
        for (const education of this.employeeDetail.education) {
          const index = this.keys.indexOf(education.education_type);
          if (index > -1) {
            newEducationHours[index] = education.total_education_hours;
            sum += education.total_education_hours;
          }
        }
        // this.educationHours 마지막 값에 합계를 입력한다.
        newEducationHours[newEducationHours.length - 1] = sum;
        
        // 전체 배열을 교체하여 반응성 보장
        this.educationHours = newEducationHours;
      }

      this.isStartLoadEmployeeDetail = false;
    },
    // float 숫자를 시간 문자열로 바꾼다. 예를 들어서 4.5를 04:30으로 바꾼다.
    floatToTimeString(floatNumber) {
      const hour = Math.floor(floatNumber);
      const minute = Math.round((floatNumber - hour) * 60);

      return `${hour.toString().padStart(2, "0")}시간 ${minute.toString().padStart(2, "0")}분`;
    },
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;

table {
  width: 100%;
  border-collapse: collapse;
}

th,
td {
  border: $border;
  padding: 15px;
  text-align: center;
  font-weight: 500;
  font-size: 14px;
}

tr:nth-child(1) {
  background-color: #fafafa;
}

tr:nth-child(2n + 1) td {
  border-top: none;
}

tr:nth-child(2n) td {
  border-bottom: none;
}

tr:first-child th:first-child,
tr:first-child td:first-child {
  border-left: none;
}

tr:first-child th:last-child,
tr:first-child td:last-child {
  border-right: none;
}

/* .hoursTd 마지막 칸은 bold 적용 */
td.hoursTd:last-child {
  font-weight: bold;
}
</style>
